import { useMutation, useQueryClient } from "@tanstack/react-query";
import { login, logout } from "../services/authApi";

export function useLoginUser(handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      console.log("User has logged in successfully!", data);
      //queryClient.setQueryData(["auth", "user"], data);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || error.message || "Login failed";
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage }); // Pass message object
    },
  });
}

export function useLogoutUser(handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: (data) => {
      console.log("User has logged out successfully!", data);
      queryClient.removeQueries(["auth", "user"]);
      handleSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || error.message || "Logout failed";
      if (extendedLog) console.log(error);
      console.log(errorMessage);
      handleError?.({ message: errorMessage }); // Pass message object
    },
  });
}
